// extracted by mini-css-extract-plugin
module.exports = {"statistics":"UdF0r","item":"_95wYt","top100_widget":"_1OJEJ"};